/**
 * i18next does not serialize overlapping changeLanguage() calls: if two are
 * triggered in quick succession (e.g. a user selection followed by a
 * programmatic revert), whichever resolves last silently wins. Routing every
 * language change through this queue guarantees they apply in call order.
 *
 * Deliberately isolated from './i18n' (which calls i18next.use(...).init()
 * at import time): pulling that module in would re-run its bootstrap in any
 * test that mocks 'react-i18next' without an `initReactI18next` export,
 * crashing with "You are passing an undefined module!".
 */
import i18next from 'i18next';

let languageChangeQueue: Promise<void> = Promise.resolve();

export function queueLanguageChange(language: string): Promise<void> {
  languageChangeQueue = languageChangeQueue
    .catch(() => undefined)
    .then(() => i18next.changeLanguage(language))
    .then(() => undefined);
  return languageChangeQueue;
}
